var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-1"},[_c('v-col',{attrs:{"cols":"10","xs":"12"}},[_c('h2',{staticClass:"martop5 margin-bottom-medium"},[_vm._v("3. Set up your security profile")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }